import React from "react";
import { formatScore, ordinalValue } from "../lib/helpers";
import { ComponentHeader } from "./ComponentHeader";

const ScoreSummaryRankScore = (props) => {
  return (
    <React.Fragment>
      <div className="grid grid-cols-2 gap-2">
        <div>
          <ComponentHeader text="Rank" />
          <div className="bg-amber-400 -mt-2 flex justify-center items-center text-4xl p-2">
            {props.rank || "-"}
            {props.rank && (
              <sup className="text-xl">{ordinalValue(props.rank)}</sup>
            )}
          </div>
        </div>
        <div>
          <ComponentHeader text="Score" />
          <div className="bg-amber-400 -mt-2 flex justify-center items-center text-4xl p-2">
            {formatScore(props.score) || "-"}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ScoreSummaryRankScore;
